export default "__VITE_ASSET__BT6Bos2n__"